import { ServicePage } from './ServicePage';
import { Bitcoin } from 'lucide-react';

const CryptoPage = () => {
  return <ServicePage serviceKey="crypto" icon={Bitcoin} />;
};

export default CryptoPage;
